import { Request } from "../request"

//获取文章详情
export function getArticleDetail(params) {
    return Request.http.post("/admin/article/getArticleDetailV1_2.html", params);
}

//获取文章相关推荐
export function getRecArticle(params) {
    return Request.http.post("/admin/article/getRecArticleV1_2.html", params);
}

//获取套餐列表
export function getComboList(params) {
    return Request.http.post("/admin/user/comboList", params);
}

//获取订阅套餐的已选频道
export function getComboCateList(params) {
    return Request.http.post("/admin/subscribe/comboCateList", params);
}

//获取订阅套餐的可选频道
export function getCateList(params) {
    return Request.http.post("/admin/subscribe/cateList", params);
}

//修改套餐名称
export function editComboName(params) {
    return Request.http.post("/admin/subscribe/editComboName", params);
}

//修改套餐已选频道列表
export function updateComboCate(params) {
    return Request.http.post("/admin/subscribe/updateComboCate", params);
}

//订阅信息流页面频道查询
export function userInfoStreamSearch(params) {
    return Request.http.post("/admin/search/userInfoStreamSearchV1_2.html", params);
}

//订阅信息流页面频道查询
export function getBaseStatistical(params) {
    return Request.http.post("/admin/apiconsole/getBaseStatistical.html", params);
}

//获取用户套餐
export function getUserCombos(params) {
    return Request.http.post("/admin/apiconsole/getUserCombos.html", params);
}

//获取折线图统计数据
export function getSeniorStatistical(params) {
    return Request.http.post("/admin/apiconsole/getSeniorStatistical.html", params);
}

//订阅信息流页面频道查询
export function getStreamSearch(params) {
    return Request.http.post("/admin/search/userInfoStreamSearchV1_2.html", params);
}



// WEBPACK FOOTER //
// ./src/api/hb/index.js